export const END_POINT_QRCODE = "http://qrcode.vmass.vn"